import React, { useEffect } from 'react';
import Slider from '../slides/Slider';
import {useNavigate} from 'react-router-dom'
import { getConcertsAndPerformances} from '../../actions/PlaylistActions'
import { useDispatch, useSelector } from 'react-redux'
import ArrowRight from '../icons/Arrow_right.svg'
import ViewAll from '../icons/ViewAllBlue.svg'

function Concerts(props) {


    const dispatch = useDispatch()

    const navigate = useNavigate()

    const playlistList = useSelector(state => state.concertsAndPerformances)

    const { concertsAndPerformances} = playlistList

    useEffect(()=>{

        if (!concertsAndPerformances || !concertsAndPerformances.length){
            dispatch(getConcertsAndPerformances())
        }

    },[dispatch])


      useEffect(()=>{
        props.playlists && props.playlists.length && props.slideRef?.slickGoTo(0)
    },[props.playlists])



      const viewAllHandler = () => {
        navigate(encodeURI(`/group/5/Concerts and Performances`))
      }


    return (
        <div className="w-100" style = {{marginTop:"2.5vw"}}>
            {
                concertsAndPerformances && concertsAndPerformances && concertsAndPerformances.length ?
                <Slider
                    num = {5}
                    type = {1}
                    showTitle = {true}
                    tvData={concertsAndPerformances}
                    slideClickHandler={props.slideClickHandler}
                    slideTitle = {"Concerts and Performances"}
                    showAllHandler = {viewAllHandler}
                /> : ""
            }   
        </div>
    );
}

export default Concerts;